export default __webpack_public_path__ + "static/media/IMG_5366.966dfc79.JPG";